"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
/** This file encapsulates map events that apply to the nodes layer, in any section */
const maplibre_gl_1 = require("maplibre-gl");
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const Node_1 = __importDefault(require("transition-common/lib/services/nodes/Node"));
const MapCursorHelper_1 = require("../MapCursorHelper");
const hoverNode = (node, nodeTitle = node.toString(false)) => {
    const popup = new maplibre_gl_1.Popup({
        offset: 10,
        anchor: 'bottom'
    });
    const nodeId = node.get('id');
    popup.setLngLat(ServiceLocator_1.default.collectionManager.get('nodes').getById(nodeId).geometry.coordinates);
    if (ServiceLocator_1.default && ServiceLocator_1.default.keyboardManager && ServiceLocator_1.default.keyboardManager.keyIsPressed('alt')) {
        popup.setHTML(`<p>${nodeTitle}<br />${nodeId}${node.attributes.data.weight ? `<br />w${Math.round(node.attributes.data.weight)}` : ''}</p>`);
    }
    else {
        popup.setHTML(`<p>${nodeTitle}</p>`);
    }
    ServiceLocator_1.default.eventManager.emit('map.addPopup', nodeId, popup);
};
const unhoverNode = (nodeId) => {
    if (ServiceLocator_1.default && ServiceLocator_1.default.keyboardManager && ServiceLocator_1.default.keyboardManager.keyIsPressed('alt')) {
        // keep popup for now when alt is pressed
    }
    else {
        ServiceLocator_1.default.eventManager.emit('map.removePopup', nodeId);
    }
};
const onNodeMouseEnter = (e) => {
    var _a, _b;
    const map = e.target;
    if (e.features && e.features[0]) {
        (0, MapCursorHelper_1.addHoverClass)();
        const nodeGeojson = e.features[0];
        const hoverNodeIntegerId = nodeGeojson.id;
        const hoverNodeId = (_a = nodeGeojson.properties) === null || _a === void 0 ? void 0 : _a.id;
        const nodesCollection = (_b = ServiceLocator_1.default.collectionManager) === null || _b === void 0 ? void 0 : _b.get('nodes');
        const nodeFeature = nodesCollection === null || nodesCollection === void 0 ? void 0 : nodesCollection.getById(hoverNodeId);
        if (!nodeFeature) {
            return; // collection or node not loaded yet
        }
        const node = new Node_1.default(nodeFeature.properties, false, ServiceLocator_1.default.collectionManager);
        // unhover previous node:
        if (map._hoverNodeIntegerId && map._hoverNodeSource && map._hoverNodeId) {
            ServiceLocator_1.default.eventManager.emit('node.unhover', map._hoverNodeId);
            e.target.setFeatureState({ source: map._hoverNodeSource, id: map._hoverNodeIntegerId }, { size: 1, hover: false });
        }
        e.target.setFeatureState({ source: nodeGeojson.source, id: hoverNodeIntegerId }, { size: 1.5, hover: true });
        // See https://github.com/alex3165/react-mapbox-gl/issues/506
        map._hoverNodeIntegerId = hoverNodeIntegerId;
        map._hoverNodeId = hoverNodeId;
        map._hoverNodeSource = nodeGeojson.source;
        hoverNode(node);
    }
};
const onNodeMouseLeave = (e) => {
    const map = e.target;
    (0, MapCursorHelper_1.removeHoverClass)();
    if (map._hoverNodeIntegerId && map._hoverNodeSource && map._hoverNodeId) {
        unhoverNode(map._hoverNodeId);
        e.target.setFeatureState({ source: map._hoverNodeSource, id: map._hoverNodeIntegerId }, { size: 1, hover: false });
    }
    map._hoverNodeIntegerId = null;
    map._hoverNodeId = null;
    map._hoverNodeSource = null;
};
const onSelectedNodeMouseEnter = (e) => {
    if (e.features && e.features[0]) {
        (0, MapCursorHelper_1.addHoverClass)();
    }
};
const onSelectedNodeMouseLeave = () => {
    (0, MapCursorHelper_1.removeHoverClass)();
};
const nodeLayerEventDescriptors = [
    { type: 'layer', layerName: 'transitNodes', eventName: 'mouseenter', handler: onNodeMouseEnter },
    { type: 'layer', layerName: 'transitNodes', eventName: 'mouseleave', handler: onNodeMouseLeave },
    { type: 'layer', layerName: 'transitNodesSelected', eventName: 'mouseenter', handler: onSelectedNodeMouseEnter },
    { type: 'layer', layerName: 'transitNodesSelected', eventName: 'mouseleave', handler: onSelectedNodeMouseLeave }
];
exports.default = nodeLayerEventDescriptors;
//# sourceMappingURL=NodeLayerMapEvents.js.map